import React from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import style from "./InfoSectionBlogMobileStyle"
import image1 from "assets/img/25/Imagen 1.jpeg";

const useStyles = makeStyles(style)

const InfoSectionBlogMobile = ({ t }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography variant="h4" component="h2" className={classes.mainTitle}>
        {t("mainTitlePart1")}
      </Typography>
      <Box
        component="img"
        src={image1}
        alt="Rising Together"
        className={classes.image}
      />
      <Typography variant="subtitle1" className={classes.subtitle}>
        {t("mainSubtitle")}
      </Typography>
      <Typography variant="body1" className={classes.bodyText}>
        {t("meetingText")}
      </Typography>
    </Box>
  );
};

export default InfoSectionBlogMobile;
